module.exports = __webpack_public_path__ + "img/emoji_160.4358bda0.png";